import React from 'react';

import { AssetTree, SearchAssetWithElements } from '@atom/types/asset';
import { CategoryPathItem, InventoryCategoryTree } from '@atom/types/category';
import { InventoryAssetDetailType } from '@atom/types/inventory';

import { FilterParams } from './InventoryAssetTreeTransfer';

export type Tree = InventoryCategoryTree | InventoryAssetDetailType | AssetTree;

interface Context {
  fetchMore: (id: string) => void;
  getData: (id: string) => Tree[];
  handleAssetClick: (
    asset: InventoryAssetDetailType | SearchAssetWithElements,
    ancestors?: CategoryPathItem[],
  ) => void;
  handleToggle: (tree: Tree, ancestors?: CategoryPathItem[]) => void;
  hasError: (id: string) => boolean;
  hasMore: (id: string) => boolean;
  isLoading: (id: string) => boolean;
  open: Set<string>;
  rootTree: InventoryCategoryTree;
  filterParams: FilterParams;
  removeAssetId: string;
}

export const initialState: Context = {
  fetchMore: () => {},
  getData: () => null,
  handleAssetClick: () => {},
  handleToggle: () => {},
  hasError: () => false,
  hasMore: () => false,
  isLoading: () => false,
  open: null,
  rootTree: null,
  filterParams: {},
  removeAssetId: '',
};

const TreeContext = React.createContext<Context>(initialState);

export default TreeContext;
